import {
  Box,
  Stack,
  Step,
  StepContent,
  StepIcon,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import Loading from "../../components/Loading";

function ConditionalStepIcon(props) {
  const { active, className } = props;

  if (active) {
    return (
      <span className={className}>
        <Loading inline={true} />
      </span>
    );
  }

  return <StepIcon {...props} />;
}

export default function MidImport({ data, sourceConfig }) {
  const steps = sourceConfig.steps;
  const activeStep = steps.findIndex((step) => step.value === data?.status);

  return (
    <>
      <Typography>
        {" "}
        This might take a little while - most libraries take less than 10
        minutes but some large libraries may take up to 30 minutes. Feel free to
        continue using the app, you can return to this page to monitor progress
        at any time
      </Typography>
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 3 }}
      >
        {activeStep === -1 ? (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            gap={1}
            alignItems={"center"}
          >
            <Loading inline />
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              <i>Checking import status…</i>
            </Typography>
          </Stack>
        ) : (
          <Stepper
            activeStep={activeStep}
            orientation="vertical"
            sx={{ width: 300 }}
          >
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel
                  StepIconComponent={ConditionalStepIcon}
                  optional={
                    index === steps.length - 1 ? (
                      <Typography variant="caption">Last step</Typography>
                    ) : null
                  }
                >
                  {step.label}
                </StepLabel>
                <StepContent>
                  <Typography>
                    {step.progress && data?.progress != null
                      ? `${data.progress}% complete`
                      : step.description || ""}
                  </Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        )}
      </Box>
    </>
  );
}
